import browser from './browser'

export default browser.getBrowserName() === 'Internet Explorer';
